import { defineMessages } from 'react-intl'; // , defineMessages

const messages = defineMessages({
  edit: {
    id: 'Edit element',
    defaultMessage: 'Edit element',
  },
  delete: {
    id: 'Remove element',
    defaultMessage: 'Remove element',
  },
});

export default messages;
